//中文繁体
export default{
    今日涨跌:"今日涨跌",
    商品:"商品",
    交割:"交割",
  关于我们:"關於我們",
  账变记录:"帳變紀錄",
  股票:"股票",
  加密货币:"加密貨幣",
  加载中:"載入中...",
  已经全部加载完毕:"已經全部加載完畢",
  暂无记录:"暫無紀錄",
  高级认证:"高級認證",
  姓名:"姓名",
  请输入姓名:"請輸入姓名",
  护照编号:"護照編號",
  请输入护照编号:"請輸入護照編號",
  护照照片:"護照照片",
  申请认证:"申請認證",
  提示:"提示",
  确定:"確定",
  提交失败:"提交失敗",
  上传失败:"上傳失敗",
  身份认证:"身份認證",
  身份证号:"身分證號",
  请输入身份证号:"請輸入身分證號",
  身份证照片:"身分證照片",
  申请认证:"申請認證",
  修改资金密码:"修改資金密碼",
  旧密码:"舊密碼",
  请输入旧密码:"請輸入舊密碼",
  新密码:"新密碼",
  请输入6位数字:"請輸入6位數字",
  确认新密码:"確認新密碼",
  请再次输入新密码:"請再次輸入新密碼",
  提交:"提交",
  请输入新密码:"請輸入新密碼",
  请输入6位数新密码:"請輸入6位數新密碼",
  请确认两次密码输入一致:"請確認兩次密碼輸入一致",
  修改登录密码:"修改登入密碼",
  密码长度:"密碼（6-12個字元）",
  密码长度提示:"請輸入6-12個字符，包括數字或字母",
  客服:"客服",
  永续:"永續",
  交割:"交割",
  永续合约:"永續合約",
  交割合约:"交割合約",
  全仓:"全倉",
  开多:"開多",
  开空:"開空",
  价格:"價格",
  开仓金额:"開倉金額",
  可用金额:"可用金額",
  合约金额:"合約金額",
  保证金:"保證金",
  手续费:"手續費",
  看涨:"看漲",
  看跌:"看跌",
  交割时间:"交割時間",
  数量:"數量",
  持有仓位:"持有部位",
  当前委托:"當前委託",
  历史订单:"歷史訂單",
  暂无数据:"暫無數據",
  购买价:"購買價",
  现价:"現價",
  金额:"金額",
  盈亏:"盈虧",
  操作:"操作",
  平仓:"平倉",
  撤单:"撤銷單",
  方向:"方向",
  剩余时间:"剩餘時間",
  交割时间:"交割時間",
  详情:"詳情",
  名称:"名稱",
  最新价格:"最新價格",
  h24涨跌:"24H漲跌",
  h24涨跌幅:"24h漲跌幅",
  请输入开仓金额:"請輸入開倉金額",
  请输入开仓价格:"請輸入開倉價格",
  确定执行撤单操作:"確定執行撤單操作？",
  确定执行平仓操作:"確定執行平倉操作？",
  交割合约历史:"交割合約歷史",
  历史仓位:"歷史部位",
  到期时间:"到期時間",
  闪兑:"閃兌",
  从:"從",
  最大:"最大",
  可用数量:"可用數量",
  至:"至",
  复制成功:"複製成功",
  基金理财:"基金理財",
  托管金额:"託管金額",
  总收益:"總收益",
  当日收益:"當日收益",
  托管订单:"託管訂單",
  规则:"規則",
  日收益:"日收益",
  限额:"限額",
  周期:"週期",
  天:"天",
  立即买入:"立即買入",
  购买:"購買",
  购买日:"購買日",
  起息日:"起息日",
  派息时间:"派息時間",
  每日:"每日",
  计息结束日:"計息結束日",
  提前赎回:"提前贖回",
  预计收益:"預計收益",
  今日日收益:"今日(日收益)",
  最少可投:"最少可投",
  最大可投:"最大可投",
  请输入买入金额:"請輸入買入金額",
  可用金额:"可用金額",
  请输入买入金额:"請輸入買入金額",
  质押金额:"質押金額",
  累计收益:"累計收益",
  开始时间:"開始時間",
  结束时间:"結束時間",
  理财规则:"理財規則",
  理财规则1:"理財是透過將USD託管給平台，由平台的專業團隊進行理財套利，參與者在資金託管期間可獲得平台的理財收入分成。",
  收益计算:"收益計算",
  理财规则2:"會員在平台存入了10000U，選擇了周期為5天 ，日收益為0.3%~0.5%的理財產品，則每天收益如下：",
  最低:"最低",
  最高:"最高",
  理财规则3:"既：5天后可以獲得",
  理财规则4:"的收益，收益每日下發，下發的收益可隨時存取，存入本金，到期滿後，自動返還至您的帳戶。",
  关于违约金:"關於違約金",
  理财规则5:"若您希望轉出未到期的本金，則會產生違約金，",
  理财规则6:"違約金=結算比例x剩餘天數x投資數。",
  理财规则7:"舉例：該產品的違約金結算比例為",
  剩余:"剩餘",
  天到期投资:"天到期，投資數量為",
  则:"則",
  违约金:"違約金",
  实际退还本金为:"實際退還本金為",
  现货账户:"現貨帳戶",
  总资产:"總資產",
  充币:"充幣",
  提币:"提幣",
  闪兑:"閃兌",
  投资组合:"投資組合",
  冻结数量:"凍結數量",
  帮助中心:"幫助中心",
  自选:"自選",
  行情:"行情",
  资金:"資金",
  资讯:"資訊",
  我的:"我的",
  交易对:"交易對",
  最新价:"最新價",
  成交量:"成交量",
  标记价格:"標記價格",
  h24最高价:"24h最高價",
  h24最低价:"24h最低價",
  h24成交量:"24h成交量",
  h24交易额:"24h交易額",
  分时:"分時",
  分1:"1分",
  分5:"5分",
  分15:"15分",
  分30:"30分",
  小时1:"1小時",
  天1:"1天",
  周1:"1週",
  月1:"1月",
  委托订单:"委託訂單",
  最新交易:"最新交易",
  买入:"買入",
  卖出:"賣出",
  时间:"時間",
  方向:"方向",
  取消自选成功:"取消自選成功",
  添加成功:"添加成功",
  登录:"登入",
  账户:"帳戶",
  邮箱:"電子郵件",
  手机号:"手機號碼",
  请输入账户:"請輸入帳戶",
  请输入邮箱:"請輸入電子郵件",
  请输入手机号:"請輸入手機號",
  密码:"密碼",
  请输入密码:"請輸入密碼",
  忘记密码:"忘記密碼?",
  还没有账号:"還沒有帳號",
  去注册:"去註冊",
  请输入登录账号:"請輸入登入帳號",
  请输入登录密码:"請輸入登入密碼",
  登录失败:"登入失敗",
  历史记录:"歷史記錄",
  充值:"儲值",
  提现:"提現",
  未审核:"未審核",
  成功:"成功",
  失败:"失敗",
  快捷入口:"快速入口",
  资金密码:"資金密碼",
  登录密码:"登入密碼",
  账变记录:"帳變紀錄",
  邀请推广:"邀請推廣",
  通用:"一般",
  语言:"語言",
  在线客服:"網路客服",
  身份认证:"身份認證",
  高级认证:"高級認證",
  更多:"更多",
  帮助中心:"幫助中心",
  关于我们:"關於我們",
  退出:"退出",
  已提交身份认证:"您已提交過身份信息，正在審核中",
  您已完成身份认证:"您已完成身份認證",
  您已完成高级认证:"您已完成高級認證",
  确定退出登录:"確定登出登入?",
  资讯:"資訊",
  公告:"公告",
  状态:"狀態",
  已成交:"已成交",
  委托金额:"委託金額",
  剩余金额:"剩餘金額",
  订单类型:"訂單類型",
  市价委托:"市價委託",
  市价: "市價",
  限价:"限價",
  限价委托:"限價委託",
  订单号:"訂單編號",
  委托时间:"委託時間",
  U本位合约历史:"U本位合約歷史",
  成交数量:"成交數量",
  实现盈亏:"實現盈虧",
  推广记录:"推廣記錄",
  我的总推广:"我的總推廣",
  总充值:"總儲值",
  一代人数:"一代人數",
  二代人数:"二代人數",
  三代人数:"三代人數",
  立即推广:"立即推廣",
  我的推广:"我的推廣",
  用户名:"使用者名稱",
  行情:"行情",
  加密货币:"加密貨幣",
  外汇:"外匯",
  股票:"股票",
  现货交易:"現貨交易",
  期货:"期貨交易",
  热门:"熱門",
  涨幅榜:"漲幅榜",
  跌幅榜:"跌幅榜",
  快速充币:"快速充幣",
  保存二维码:"儲存二維碼",
  复制地址:"複製地址",
  转出地址:"轉出地址(選填)",
  请输入转出地址:"請輸入轉出地址",
  粘贴:"貼上",
  充币数量:"充幣數量",
  请输入充币数量:"請輸入充幣數量",
  区块链网络:"區塊鏈網絡",
  付款凭证:"付款憑證（上傳支付詳情截圖）",
  请输入充值数量:"請輸入儲值數量",
  充值通道:"儲值通道",
  请选择充值币种:"請選擇充值幣種",
  官方充值通道:"官方儲值通道",
  设置密码:"設定密碼",
  确认密码:"確認密碼",
  验证码:"驗證碼",
  请输入验证码:"請輸入驗證碼",
  获取验证码:"取得驗證碼",
  重新发送:"重新發送",
  邀请码:"邀請碼",
  请输入邀请码:"請輸入邀請碼",
  我已阅读并同意:"我已閱讀並同意",
  服务条款:"服務條款",
  注册:"創建帳號",
  已有账号:"已有帳號",
  去登录:"去登入",
  请再次输入密码:"請再次輸入密碼",
  请同意服务条款:"請同意服務條款",
  注册失败:"註冊失敗",
  欢迎来到:"歡迎來到",
  全球最大的区块链资产平台:"全球最大的區塊鏈資產平台",
  全球领先的期货和数字资产平台:"全球領先的期貨和數字資產平台",
  分享二维码:"分享二維碼",
  链接分享:"連結分享",
  复制:"複製",
  您的邀请码:"您的邀請碼",
  到数字币地址:"到數位幣地址",
  选择币种:"選擇幣種",
  区块链网络:"區塊鏈網絡",
  提币说明:"提幣說明",
  提现费用:"提現費用",
  可到账数量:"可到帳數量",
  可用:"可用",
  请输入支付密码:"請輸入支付密碼",
  请输入提币数量:"請輸入提幣數量",
  全部:"全部",
  支付密码:"支付密碼",
  地址:"地址",
  委托价:"委託價",
  成交时间:"成交時間",
  成交金额:"成交金額",
  委托中:"委託中",
  持仓中:"持倉中",
  平仓中:"平倉中",
  已平仓:"已平倉",
  开仓倍数:"開倉倍數",
  委托价格:"委託價格",
  收盘价:"收盤價",
  收益率:"殖利率",
  平仓时间:"平倉時間",
  请输入转换数量:"請輸入轉換數量",
  请上传付款凭证:"請上傳付款憑證",
  开盘价:"開盤價",
  开市中:"開市中",
  已休市:"已休市",
  美股:"美股",
  平仓价:"平倉價",
  到期结算完成:"到期結算完成",
  印度股票:"印度股票",
  马来股票:"馬來股票",
  结算中:"結算中",
  越南股票:"越南股票",
  设置资金密码:"設定資金密碼",
  请输入资金密码:"請輸入資金密碼",
  取消:"取消",
  确定:"確定",
  止损价:"停損價",
  请输入止损价格:"請輸入停損價格",
  请输入止盈价格:"請輸入止盈價格",
  止盈价:"止盈價",
  设置止盈止损:"設定止盈止損",
  请输入关键词:"請輸入關鍵字",
  搜索结果:"搜尋結果",
  添加收款方式:"新增收款方式",
  高级认证:"高級認證",
  历史委托:"歷史委託",
  选择区域码:"選擇區域碼",
  请上传身份证图片:"請上傳身分證圖片",
  请上传护照照片:"請上傳護照照片",
  请输入提币地址:"請輸入提幣地址",
  设置语言:"設定語言",
  最低金额: "最低金額",
  购买金额: "購買金額",
  请输入要搜索的国家名称: "請輸入要搜尋的國家名稱",
  确定执行该操作: "確定執行該操作?",
  历史搜索: "歷史搜尋",
  现货持仓: "現貨持倉",
  永续持仓: "永續持倉",
  到期结算中: "到期結算中",
  火花图: "火星圖",
  计价单位: "計價單位",
  您拒绝了链接: "您拒絕了連結",
  连接钱包成功: "連結錢包成功",
  已断开钱包: "已斷開錢包",
  钱包切换成功: "錢包切換成功",
  请先安装钱包插件: "請先安裝錢包插件",
  连接钱包: "連接錢包",
  交易: "交易",
  确认报价: "確認報價",
  您将获得: "您將獲得",
  兑换自: "兌換自",
  汇率: "匯率",
  返回: "返回",
  兑换: "兌換",
  消息: "訊息",
  身份证反面照片: "身分證反面照片",
  身份证正面照片: "身分證正面照片",
  手持身份证照片: "手持身分證照片",
  划转: "劃轉",
  请输入划转数量: "請輸入劃轉數量(USD)",
  邀请链接: "邀請連結",
  资料总览: "資料總覽",
  推广规则: "推廣規則",
  总邀请人数: "總邀請人數",
  总佣金: "總佣金",
  规则1: "1.该地址仅接受{type}，请勿往该地址转入非{type}资产，否则资产将不可找回",
  规则2: "2.您充值上述地址后，需要等待网络节点确认，一旦网络节点确认后，资产会自动到账，我们将以网站公告形式通知您到账情况。",
  规则3: "3.您的充值地址不会经常改变，可以重复充值；如有更改，我们会以网站公告通知您",

  安全绑定: "安全绑定",
  安全中心: "安全中心",
  绑定手机号: "綁定手機號",
  认证中心: "認證中心",
  认证要求: "認證要求",
  政府发行的证件: "政府發行的證件",
  功能与限制: "功能與限制",
  无限额: "無限額",
  预计审核时间: "预计审核时间：60分钟",
  开始认证: "開始認證",
  充币规则: "充幣規則",
  套期保值: "避險，風險對沖",
  登陆后继续: "登陸後繼續",
  请选择充值方式: "請選擇充值方式",
    请选择取款方式: "請選擇取款方式",
    客服充值: "客服充值",
    数字货币: "數字貨幣",
    银行取款: "銀行取款",
    请输入金额: "請輸入金額",
    银行名称: "銀行名稱",
    银行卡号: "銀行卡號",
    请输入: "請輸入",
    请选择: "請選擇",
    类型: "類型",
    可用金额: "可用金額",
    提款: "提款"
  }
  
  
  


// WEBPACK FOOTER //
// ./src/lang/cn.js